
import { Box } from "@mui/material";
import { Typography } from "components/ui";
import React from "react";

const GameHeader = ({ roomCode, userName }) => {
    return (
        <Box sx={{ px: 2, mb: 2 }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                }}
            >
                <Box>
                    <Typography $size="0.9em" color="textSecondary">
                        ROOM
                    </Typography>
                    <Typography $size="1.2em" $bolds color="primary">
                        {roomCode}
                    </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography $size="2.5em" $bolds>
                        {userName}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default GameHeader;
